import { createTheme } from '@mui/material/styles'

import { mainColors } from '@/styles/index'

/** Matches body / MUI typography; use in Monaco script editors for consistent UI text. */
export const APP_FONT_FAMILY = "'Blinker', sans-serif"

// Define a custom theme with a grey palette
export const theme = createTheme({
	typography: {
		fontFamily: APP_FONT_FAMILY,
	},
	palette: {
		primary: {
			light: '#51838e',
			main: '#265560',
			dark: '#002c36',
			contrastText: '#fff',
		},
		secondary: {
			light: '#ffddcf',
			main: '#d9aa9f',
			dark: '#a67b70',
			contrastText: '#000',
		},
		emerald: {
			main: '#ecfdf5',
			dark: '#d1fae5',
		},
	},
	components: {
		MuiTableHead: {
			styleOverrides: {
				root: {
					'.MuiTableRow-root': {
						backgroundColor: mainColors.primary,
					},
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				head: {
					color: 'white', // Header text color
					'& .MuiTableSortLabel-root': {
						color: 'white', // Sort label (text)

						'&:hover': {
							color: 'white', // Text color when hovered
						},

						'&.Mui-active': {
							color: 'white', // Text color when the column is active (sorted)
							'& .MuiTableSortLabel-icon': {
								color: 'white !important', // Sort arrow color when active
							},
						},
					},
					'& .MuiSvgIcon-root': {
						color: 'white !important', // Filter, three dots icon color
						'&:hover': {
							color: 'white !important', // Hover state color for filter and icons
						},
					},
					'&[data-pinned="true"]:before': {
						backgroundColor: 'unset !important',
						boxShadow: 'unset !important',
					},
				},
			},
		},
		MuiTextField: {
			defaultProps: {
				InputLabelProps: {
					shrink: true,
				},
			},
		},
		MuiInputLabel: {
			defaultProps: {
				shrink: true,
			},
			styleOverrides: {
				root: {
					fontSize: '1rem',
					fontWeight: 600,
					'&.Mui-disabled': {
						color: 'rgba(0, 0, 0, 0.6)',
					},
				},
			},
		},
		MuiSelect: {
			defaultProps: {
				notched: true,
			},
			styleOverrides: {
				root: {
					'&.Mui-disabled': {
						backgroundColor: '#fafafa',
					},
				},
				select: {
					'&.Mui-disabled': {
						WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					'&.Mui-disabled': {
						backgroundColor: '#fafafa',
					},
				},
				input: {
					'&.Mui-disabled': {
						WebkitTextFillColor: 'rgba(0, 0, 0, 0.87)',
					},
				},
			},
		},
		// Single source of truth for input/textarea text so Name/Code/Description render the same
		MuiInputBase: {
			styleOverrides: {
				input: {
					fontSize: '1rem !important',
					lineHeight: '1.4375 !important',
					fontFamily: 'inherit',
				},
			},
		},
	},
})

export default theme
